/**
 * köbi Produktgalerie — Dot-Kürzung
 * Setzt `data-dot-state` auf jeden Slider-Counter-Button basierend auf der
 * Entfernung zur aktiven Slide. Die CSS in koebi-product.css interpretiert
 * das Attribut für Größe/Sichtbarkeit (iOS-Photos-Pattern).
 *
 *   - Bis 7 Dots: keine Kürzung (alle voll sichtbar).
 *   - Ab 8: Fenster von 5 „normal"-großen Dots zentriert auf der aktiven
 *     Slide, je 1 „small" + 1 „tiny" als Edge-Indikator außerhalb,
 *     dahinter „hidden" (width: 0).
 */
(function () {
  'use strict';

  var WINDOW = 5;            // Anzahl voll sichtbarer Dots
  var TRUNCATE_THRESHOLD = 7; // ab dieser Anzahl wird gekürzt

  function updateDotStates(galleryEl) {
    var dots = Array.prototype.slice.call(
      galleryEl.querySelectorAll('.koebi-product-gallery__dots-bar .slider-counter__link--dots')
    );
    var total = dots.length;
    if (!total) return;

    if (total <= TRUNCATE_THRESHOLD) {
      dots.forEach(function (d) {
        d.removeAttribute('data-dot-state');
      });
      return;
    }

    var activeIdx = -1;
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].classList.contains('slider-counter__link--active')) {
        activeIdx = i;
        break;
      }
    }
    if (activeIdx === -1) return;

    var halfWin = Math.floor(WINDOW / 2);
    var winStart = activeIdx - halfWin;
    var winEnd = activeIdx + halfWin;

    if (winStart < 0) {
      winEnd -= winStart;
      winStart = 0;
    }
    if (winEnd > total - 1) {
      winStart -= (winEnd - (total - 1));
      winEnd = total - 1;
      if (winStart < 0) winStart = 0;
    }

    dots.forEach(function (dot, idx) {
      var state;
      if (idx >= winStart && idx <= winEnd) {
        state = 'normal';
      } else if (idx === winStart - 1 || idx === winEnd + 1) {
        state = 'small';
      } else if (idx === winStart - 2 || idx === winEnd + 2) {
        state = 'tiny';
      } else {
        state = 'hidden';
      }
      dot.setAttribute('data-dot-state', state);
    });
  }

  function initGallery(galleryEl) {
    // Initialer Pass nach Layout-Settle
    window.setTimeout(function () {
      updateDotStates(galleryEl);
    }, 50);

    // Aktiv-Klasse wird von SlideshowComponent.update() bei jedem Scroll-
    // Event neu gesetzt — MutationObserver auf den Dots-Bar fängt das ab,
    // unabhängig von der genauen Reihenfolge der Event-Listener.
    var dotsBar = galleryEl.querySelector('.koebi-product-gallery__dots-bar');
    if (dotsBar && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        updateDotStates(galleryEl);
      });
      observer.observe(dotsBar, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    }
  }

  function init() {
    var galleries = document.querySelectorAll('slideshow-component.koebi-product-gallery');
    galleries.forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
